import { React, useState } from 'react';
// import IntlMessages from '@iso/components/utility/intlMessages';
// import Checkbox, { CheckboxGroup } from '@iso/components/uielements/checkbox';
import Box from '@iso/components/utility/box';
import ContentHolder from '@iso/components/utility/contentHolder';
// import Button from '@iso/components/uielements/button';
import { Input, Spin, Form } from 'antd';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { useContext } from 'react';
import { AppContext } from '../../../context/ContextProvider';
import styled, { createGlobalStyle } from 'styled-components';
import Select from '../../Deployments/Deployment.styles';
import {
    SelectOption as Option,
} from '@iso/components/uielements/select';
import initialData from '../../../redux/scrumBoard/data';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { borderRadius } from '../../../library/helpers/style_utils';
import {
    PlusOutlined
} from '@ant-design/icons';
import plusIcon from '../../../assets/images/plusIcon.svg';
import { Link } from 'react-router-dom';
import CreateTaskFooter from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';
import deleteIcon from '../../../assets/images/tagsDelete.svg';
import { Switch } from 'antd';
import downIcon from '../../../assets/images/downArrow.svg';
import upIcon from '../../../assets/images/upArrow.svg';
import api from '../../../api';
import InputWithSuffix from '../../../components/uielements/input';
import { LoadingOutlined } from '@ant-design/icons';
import { BreadcrumbContext } from '../../../context/breadcrumbContext';


const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }
`;

var optionAzs = [];

let innerTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "14px"
};

let innerSubtitleStyle = {
    fontSize: "12px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

const inputStyle = {
    height: "44px"
}

export default function K8sDashboardDrawer({
    // handleSubmit,
    data,
    setData,
    values,
    submitCount,
    onClose,
    onCancel,
    refresh,
    setRefresh,
    onDelete,
    openDrawer,
    updateOnlyChangedAddons,
    onEditCancel,
    tabSelected,
    openAddOns,
    openConfigDrawer,
    isReInstall,
    column_id,
}) {

    const { openRightDrawer, setOpenRightDrawer, allClusters, setAllClusters, currentCluster, setCurrentCluster, updateCluster, setUpdateCluster, oneClickCluster, setOneClickCluster, clusterTabSelected, fetchingClusterPrerequisites, setFetchingClusterPrerequisites, isOneClick, isUpdate, overviewData } = useContext(AppContext);
    const { pageHeading } = useContext(BreadcrumbContext);
    const navigate = useNavigate();

    const [k8sDashboardData, setK8sDashboardData] = useState(isOneClick ? { ...oneClickCluster[clusterTabSelected].k8sDashboard } : isUpdate ? { ...updateCluster[clusterTabSelected].k8sDashboard } : { ...currentCluster[clusterTabSelected].k8sDashboard });
    console.log("k8sDashboardData: ", updateCluster[clusterTabSelected], clusterTabSelected)
    const [hostedZones, setHostedZones] = useState([]);
    const [validateDomainStatus, setValidateDomainStatus] = useState("");
    // const [refreshIntervalList, setRefreshIntervalList] = useState([]);
    // const [objExpirationList, setObjExpirationList] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [form] = Form.useForm();

    const [error, setError] = useState({
        status: false,
        msg: ""
    });

    const [dnsMsg, setDnsMsg] = useState({
        error: false,
        msg: ""
    });
    const selectedCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;

    useEffect(() => {
        setFetching(true);
        let arr = [];
        let selectedCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;
        console.log("MY k8s: ", selectedCluster);
        selectedCluster[clusterTabSelected].hostedZones && Object.keys(selectedCluster[clusterTabSelected].hostedZones).map((val, id) => {
            selectedCluster[clusterTabSelected].hostedZones[val].hosted_zones.map((zone, idx) => {
                arr.push(
                    // <Option key={idx} name="hostname" data-alias={val} data-type={currentCluster[clusterTabSelected].hostedZones[val].type} value={zone}>{zone}</Option>
                    <Option key={`${idx}-${id}`} name="hostname" data-alias={val} data-type={selectedCluster[clusterTabSelected].hostedZones[val].type} value={zone}>
                        <div key={`${idx}-a`} style={{display: "flex", justifyContent: "start", alignItems: "center"}}>
                            <span key={`${idx}-b`} title={zone} style={{ flex: "-1", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>
                                {zone}
                            </span>
                        </div>
                    </Option>
                );
            })
        });
        
        setHostedZones(arr);
        setFetching(false);
    }, [currentCluster[clusterTabSelected].hostedZones, updateCluster[clusterTabSelected].hostedZones, oneClickCluster[clusterTabSelected].hostedZones]);

    useEffect(() => {
        console.log("updateCluster.selectedCluster: ", updateCluster.selectedCluster)
        console.log("column_id: ", column_id)
        // if(!isUpdate) {
            let myTimeout = setTimeout(() => {
                if((k8sDashboardData.recordPrefix && k8sDashboardData.recordPrefix !== "") && ((!isUpdate && !isOneClick) || (isOneClick) || (isUpdate && ((k8sDashboardData.hostname !== updateCluster.selectedCluster.addons_data?.["kubernetes-dashboard"]?.user_values?.hosted_zone) || (k8sDashboardData.recordPrefix !== updateCluster.selectedCluster.addons_data?.["kubernetes-dashboard"]?.user_values?.record_prefix)))) /*&& !isUpdate*/){
                    let selectedCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;
                    let checkFor = column_id === "kubernetes-dashboard" ? "kubernetes-dashboard" : selectedCluster[clusterTabSelected].selectedAddons.find(val => val.name === "kubernetes-dashboard")?.name;

                    if(checkFor){
                        dnsCheck(k8sDashboardData.recordPrefix, k8sDashboardData.hostname, k8sDashboardData.zoneId, k8sDashboardData.dnsRecordType, checkFor);
                    }
                }
            }, 2000);
    
            return () => clearTimeout(myTimeout);
        // }
    }, [k8sDashboardData.recordPrefix, k8sDashboardData.hostname, k8sDashboardData.recordPrefix]);

    const handleSelectChange = (value, event) => {
        console.log("event :", event);
        console.log("value :", value);

        if (event.name === "hostname") {
            k8sDashboardData.zoneId = event["data-alias"];
            k8sDashboardData.dnsRecordType = event["data-type"];
            k8sDashboardData[event.name] = value;
            k8sDashboardData.default_zone = value;


            setDnsMsg({
                error: false,
                msg: ""
            });
        }
        else {
            k8sDashboardData[event.name] = value;
        }

        console.log("k8sDashboardData :", k8sDashboardData);
        setK8sDashboardData({ ...k8sDashboardData });
        setError({
            status: false,
            msg: ""
        });
    };

    const handelInputChange = (e) => {
        setK8sDashboardData({ ...k8sDashboardData, [e.target.name]: e.target.value });
        if(e.target.name === "recordPrefix") {
            setDnsMsg({
                error: false,
                msg: ""
            });
            // setTimeout(() => {
            //     if(e.target.value !== ""){
            //         console.log("My value: ", e.target.value, k8sDashboardData);
            //         dnsCheck(e.target.value, k8sDashboardData.hostname, k8sDashboardData.zoneId, k8sDashboardData.dnsRecordType);
            //     }
            // }, 2000);
        }
        setError({
            status: false,
            msg: ""
        });
    };

    const handleCancel = (e) => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                k8sDashboardData: "",
            },
        });

        // onClose();
    };

    const handleSaveDetails = async (e) => {
        try {
            const values = await form.validateFields();
            console.log('Success:', values);
            console.log('k8sDashboardData :', k8sDashboardData);
            let selectedCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;

            selectedCluster[clusterTabSelected].k8sDashboard = k8sDashboardData;
            let updatedAddonData = {}

            for(let i=0;i<selectedCluster[clusterTabSelected].selectedAddons.length;i++) {
                if(selectedCluster[clusterTabSelected].selectedAddons[i].name === "kubernetes-dashboard") {
                    updatedAddonData = selectedCluster[clusterTabSelected].selectedAddons[i];

                    if(dnsMsg.error) {
                        selectedCluster[clusterTabSelected].selectedAddons[i] = {
                            ...selectedCluster[clusterTabSelected].selectedAddons[i],
                            message: dnsMsg.msg,
                            borderColor: "red"
                        };
                        // if(isUpdate) {
                        //     updateCluster = {...selectedCluster};
                        // }
                        // else if(isOneClick) {
                        //     oneClickCluster = {...selectedCluster};
                        // }
                        // else {
                        //     currentCluster = {...selectedCluster};
                        // }
                        break;   
                    }
                    else {
                        selectedCluster[clusterTabSelected].selectedAddons[i] = {
                            ...selectedCluster[clusterTabSelected].selectedAddons[i],
                            message: "",
                            borderColor: "#f5f5f5"
                        };
                        // if(isUpdate) {
                        //     updateCluster = {...selectedCluster};
                        // }
                        // else if(isOneClick) {
                        //     oneClickCluster = {...selectedCluster};
                        // }
                        // else {
                        //     currentCluster = {...selectedCluster};
                        // }
                        break;
                    }
                }
            }

            console.log("selectedCluster: ", selectedCluster);

            if (isUpdate) {
                setUpdateCluster({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                });
                localStorage.setItem('updateCluster', JSON.stringify(({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                })));
            }
            else if (isOneClick) {
                setOneClickCluster({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                });
                localStorage.setItem('oneClickCluster', JSON.stringify({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                }));
            }
            else {
                setCurrentCluster({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                });
                localStorage.setItem('Cluster', JSON.stringify({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                }));
            }

            console.log("updatedAddonData :", updatedAddonData);
            console.log("openConfigDrawer :", openConfigDrawer);
            
            if(!isUpdate){
                setRefresh(refresh => !refresh);
            }
            else if(isUpdate && updatedAddonData?.selected){
                !openConfigDrawer && updateOnlyChangedAddons(updatedAddonData);
                openConfigDrawer && openConfigDrawer();
            }

            !openConfigDrawer && setOpenRightDrawer({
                drawerType: false,
                drawerProps: {
                    k8sDashboardData: "",
                },
            });
        }
        catch (err) {
            console.log("Error :", err);
        }
    };

    //   const filterClusterLogOption = (input, option) => (option?.value.toLowerCase() ?? '').includes(input.toLowerCase());

    //   const filterVPCLogOption = (input, option) => (option?.value.toLowerCase() ?? '').includes(input.toLowerCase());

    const dnsCheck = (recordPrefix, zoneName, zoneId, dnsRecordType, checkFor) => {
        setValidateDomainStatus("validating");
        api.post('/api/cluster/check-dns/', [{
            "record_name": recordPrefix,
            "zone_id": zoneId,
            "dns_record_type": dnsRecordType,
            "zone_name": zoneName,
            "check_for": checkFor
        }]).then((res) => {
            let data = res.data;
            if(data.status) {
                setDnsMsg({
                    error: false,
                    msg: typeof data.data === "object" ? Object.values(data.data)[0] : "Something went wrong. Please try again."
                });
                setValidateDomainStatus("success");
            }
            else {
                setDnsMsg({
                    error: true,
                    msg: Array.isArray(data.error_details) ? Object.values(data.error_details[0])[0] 
                        : (typeof data.error_details === "object" && data.error_details !== null)
                            ? Object.values(data.error_details)[0] 
                            : "Something went wrong. Please try again."
                });
                setValidateDomainStatus("error");
            }
        }).catch((err) => {
            console.log("Error");
            setValidateDomainStatus("error");
        });
    }


    return (
        <ProdContentHold>
            <CreateTaskHeader
                buttonContent="kubernetes-dashboard"
                data={k8sDashboardData}
                // values={{editing: true}}
                onCancel={() => {
                    setOpenRightDrawer({
                        drawerType: false,
                        drawerProps: {
                            k8sDashboardData: "",
                        },
                    });
                    // onClose();
                }}
                onDelete={onDelete}
                onEditCancel={() => {
                    setOpenRightDrawer({
                        drawerType: false,
                        drawerProps: {
                            k8sDashboardData: "",
                        },
                    });
                    // onClose();
                }}
            />

            <Form
                form={form}
                initialValues={{ ...k8sDashboardData }}
                preserve={false}
                name="dynamic_rule"
                // disabled={isUpdate}
            >

                <Box
                    title={"Hostname*"}
                    subtitle={"Enter the hostname for the dashboard"}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                    style={{ marginTop: "80px" }}
                >
                    <ContentHolder>
                        <Form.Item
                            name="recordPrefix"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please provide hostname prefix.',
                                },
                                {
                                    // Custom validator for special characters
                                    validator: (_, value) => {
                                        const specialCharPattern = /^([a-z0-9]+\.*-*)+$/; // This regex allows only letters, numbers, and spaces
                                        let selectedCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;
                                        if(value === selectedCluster[clusterTabSelected].grafanaStack.recordPrefix){
                                            return Promise.reject(new Error('Hostname should not be same as Grafana Stack hostname.'));
                                        }
                                        else if (!value || specialCharPattern.test(value)) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Hostname should start with alphanumeric char and can contain numbers, lowercase letters, hyphens or full stops.'));
                                    }
                                }
                            ]}
                        >
                            <InputWithSuffix
                                name="recordPrefix"
                                className='inputAddonAfter'
                                value={k8sDashboardData.recordPrefix}
                                // styles={{...inputStyle}}
                                style={{ height: "44px !important", zIndex: 1 }}
                                onChange={handelInputChange}
                                placeholder="hostname"
                                suffix={validateDomainStatus === "validating" ? <LoadingOutlined /> : <></>}
                                addonAfter={
                                    <Select
                                        defaultValue={(isUpdate && selectedCluster[clusterTabSelected].k8sDashboard.already_present) ? k8sDashboardData.hostname : selectedCluster[clusterTabSelected].k8sDashboard.default_zone}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        onChange={handleSelectChange}
                                        border={0}
                                        className="cusIntSelectDrop"
                                        style={{ padding: "0", borderRadius: "6px !important", zIndex: 1 }}
                                    >
                                        {fetching
                                            ?
                                            <Option>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                                    <Spin size="small" />
                                                </div>
                                            </Option>
                                            :
                                            hostedZones
                                        }
                                    </Select>
                                }
                            />
                        </Form.Item>
                        <p style={{color: dnsMsg.error ? "red" : "green"}}> {dnsMsg.msg} </p>
                    </ContentHolder>
                </Box>

                <Box style={{ height: "150px" }}>
                    <Box>
                    </Box>
                </Box>
            </Form>
            <CreateTaskFooter buttonContent={"Grafana Stack"} givenButtonFunction1={handleSaveDetails} disabled={!overviewData?.permissions?.includes("update") && pageHeading?.title !== "Add Addons"} givenButtonFunction2={handleCancel} openDrawer={openDrawer} onUpdate={openConfigDrawer ? true : false} isReInstall={isReInstall} />
        </ProdContentHold>
    );
};
